import type { IconSvgObject } from './types';

const SortingOneNineIcon: IconSvgObject = [
  ["path", { d: "M8.5 10H5.5M7 10V3H6.5L5.5 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 17.5V14H5V17.5H9ZM9 17.5V21H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 17L17 20L20 17M17 4V19.3912", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SortingOneNineIcon;
